import * as React from 'react';
import { IError } from '../schemas/core-schema';
import { core_apimessages_Error } from '../schemas/rql';
import { decamelizeKeys } from 'humps';
import ValidationErrors from './validation_errors';

interface Props {
  validationErrors: core_apimessages_Error[];
}
export default function RQLValidationErrors(props: Props) {
  const validationErrors = props.validationErrors.map(e => decamelizeKeys(e)) as IError[];
  return <ValidationErrors validationErrors={validationErrors} />;
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/onboarding/rql_validation_errors.tsx